import { FormattedMessage } from 'react-intl';

import type { FiltersGroup } from '@sorare/core/src/lib/filters';
import {
  cardAttributes,
  glossary,
  navLabels,
} from '@sorare/core/src/lib/glossary';

import { BackendGameweekFilter } from '#src/searchCards/FixtureFilter/index.tsx';
import { RefineBackendCardPlayerAge } from '#src/searchCards/RefineAge/index.tsx';
import { RefineBackendAppearances } from '#src/searchCards/RefineAppearances/index.tsx';
import { RefineBackendActiveClub } from '#src/searchCards/RefineClubs/index.tsx';
import {
  RefineBackendActiveLeague,
  RefineBackendActiveNationalTeam,
  RefineBackendNationality,
  RefineBackendPlayer,
  RefineBackendPlayingStatus,
} from '#src/searchCards/RefineList/index.tsx';
import {
  MatchInfoGroup,
  PlayerGroup,
} from '#src/searchCards/football/cardFilters.tsx';
import {
  BackendRefineCompetitionEligibility,
  RefineBackendAverageScore,
  RefineBackendPosition,
  RefinePosition,
} from '#src/searchCards/index.ts';

import { BackendMarketValuesGroup, MarketValuesGroup } from './common.tsx';

export const BackendCompetitionEligibilityGroup = {
  slug: 'eligibility',
  title: <FormattedMessage {...navLabels.gamingCompetitions} />,
  filters: [BackendRefineCompetitionEligibility],
};

export const scoutingCenterMarketFilters: FiltersGroup[] = [
  MarketValuesGroup,
  PlayerGroup({
    withPositions: true,
    withPlayingStatus: true,
  }),
  MatchInfoGroup,
];

export const scoutingCenterBackendMarketFilters: FiltersGroup[] = [
  BackendMarketValuesGroup,
  {
    slug: 'player',
    title: <FormattedMessage {...cardAttributes.player} />,
    filters: [
      RefineBackendPosition(),
      RefineBackendPlayingStatus,
      RefineBackendCardPlayerAge,
      RefineBackendNationality,
      RefineBackendPlayer,
      RefineBackendActiveLeague(),
      RefineBackendActiveClub(),
      RefineBackendActiveNationalTeam,
    ].filter(Boolean),
  },
  {
    slug: 'match-info',
    title: <FormattedMessage {...glossary.matchInfo} />,
    filters: [
      BackendGameweekFilter,
      RefineBackendAverageScore(),
      RefineBackendAppearances(),
    ],
  },
];

export const scoutingCenterMarketDropdownFilters = [RefinePosition()];
export const scoutingCenterBackendMarketDropdownFilters = [
  RefineBackendPosition(),
];
